import axios from "axios";
import { baseUrl } from "../Common/Constants"; import httpClient from "../Core/http";

import { AxiosRequestConfig } from "axios";

class PartwearoutApi {


    fetchUniqueHeaders(params: any, signal: any): Promise<any> {
        let url = "mdc/uniqueCumulativeHeaders";
        return new Promise((resolve, reject) => {
            httpClient.get<any>(url, { params: params, signal: signal })
                .then((response: any) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
        fetchHeaderStats(params: any, signal: any): Promise < any > {
            let url = "mdc/headerStats";
            return new Promise((resolve, reject) => {
                httpClient.get<any>(url, { params: params, signal: signal })
                    .then((response: any) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }

    fetchUniqueUnitsperCadidDesc(params: any, signal: any): Promise<any> {
        params.terms = {};
        let url = "mdc/uniqueUnitsperCadidDesc";
        return new Promise((resolve, reject) => {
            httpClient.get<any>(url, { params: params, signal: signal })
                .then((response: any) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
   

}


export const Api = new PartwearoutApi();